
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

export default class StageBaseController {
	constructor($log, $state, $timeout, $interval, Dialog, Session, stage) {
		'ngInject';
		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
		this.Session = Session;
		this.Dialog = Dialog;
		this.lodash = _;
		this.title = "";
		this.stage = stage;
		this.$interval = $interval;
	}	

	startGame(){
		if(!this.Session.get().stages[this.stage].completed)
			this.step = this.Session.get().stages[this.stage].levels-1;
		else
			this.step = 0;
		this.startTimer();
	}

	startTimer(){
		this.timerString = "00:00";
		this.totalSeconds = 0;
		this.stopTime = this.$interval(this.updateTime.bind(this), 1000);
	}

	updateTime(){
		this.totalSeconds++;
		let secondsLabel = this.pad(this.totalSeconds % 60);
		let minutesLabel = this.pad(parseInt(this.totalSeconds / 60));
		this.timerString = minutesLabel+":"+secondsLabel;
	}

	pad(val) {
		let valString = val + "";
		if (valString.length < 2) {
			return "0" + valString;
		} else {
			return valString;
		}
	}

	barSize(c){
		let code = this.stageCode(c);
		let level = this.Session.get().stages[code].levels;
		let barClass = '';
		switch(level){
			case 2:
			barClass = 'a-third';
			break;
			case 3:
			barClass = 'two-thirds';
			break;
			case 4:
			barClass = 'full';
			break;
			default:
			barClass = 'empty';
		}
		return barClass;
	}

	stageCode(color){
		let code = -1;
		switch(color){
			case 'red':
			code = 0;
			break;
			case 'blue':
			code = 1;
			break;
			case 'yellow':
			code = 2;
		}
		return code;
	}

	endGame(){
		let timer = this.timerString;
		let $ctrl = this;
		this.$interval.cancel(this.stopTime);
		this.$timeout(function(){
			$ctrl.Session.countLevel(timer, $ctrl.stage);
			$ctrl.Dialog.showFeedback($ctrl.step+1,$ctrl.stage,$ctrl.nextLevel.bind($ctrl));
		},2000)		
	}

	nextLevel(){
		if(this.step<2){
			this.step++;
			this.startTimer();
		} else {
			this.redirectToStages();
		}
	}

	redirectToStages(){
		this.$state.go('main');
	}

	resetStage() {        
		return false;
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-base.controller.js